<a [href]="link" target="_blank" class="suport-button">
    <img src="./assets/question-circle.svg" alt="">
</a>
